export type IUserProfileType = "cliente" | "transportador" | "CIF" | "FOB";

export const userProfileTypeList = [
  {
    value: "CL01",
    label: "Cliente",
  },
  {
    value: "TR01",
    label: "Transportador",
  },
  {
    value: "CIF",
    label: "Motorista CIF",
  },
  {
    value: "FOB",
    label: "Motorista FOB",
  },
];

export const getLabelProfileTypeList = (profileValue: string) => {
  return userProfileTypeList.find(
    (profileType) => profileType.value === profileValue
  )?.label;
};
